import ColorScheme from 'mini-color-utils/lib/ColorScheme';
import EventScope from 'owa-service/lib/contract/EventScope';
import { getDefaultMiniColorScheme } from 'mini-color-utils/lib/colorUtils';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { lazyShowConfirmDialogInBottomSheet } from 'mini-confirm-dialog-new';

/**
 * Wrapper Utility to show delete with a confirm dialog
 * @param eventScope
 * @param onConfirmClick
 * @param onCancelClick
 * @param onOverlayClick
 * @param colorScheme
 */
export const createAndShowDeleteConfirmDialog = (
    eventScope: EventScope,
    onConfirmClick: () => void,
    onCancelClick: () => void,
    onOverlayClick?: () => void,
    colorScheme: ColorScheme = getDefaultMiniColorScheme()
) => {
    const strings = getOwaMiniCommonStrings();
    lazyShowConfirmDialogInBottomSheet.importAndExecute({
        title: strings.deleteEventConfirmationTitleText,
        description:
            eventScope === EventScope.AllInstancesInSeries
                ? strings.deleteEventSeriesConfirmationSubText
                : strings.deleteEventConfirmationSubText,
        confirmButton: {
            text: strings.deleteButtonLabel,
            onClick: onConfirmClick,
        },
        cancelButton: {
            text: strings.discardButtonLabel,
            onClick: onCancelClick,
        },
        onOverlayClick: onOverlayClick,
        colorScheme,
    });
};
